import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  DomSanitizer,
  SafeResourceUrl
} from '@angular/platform-browser';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-vehicle-visuals-player',
  template: require('./vehicle-visuals.player.component.html')
})
export class VehicleVisualsPlayerComponent implements OnInit {
  /**
   * Delay between the iframe `load` event and revealing the player.
   * The iframe's load fires when HTML parses, before the vendor's player
   * has decoded the video and rendered its first frame; lifting the block
   * immediately would expose a black frame.
   */
  private static readonly IFRAME_READY_DELAY_MS = 1500;

  @BlockUI('vehicleVisualsPlayerBlock') playerBlock!: NgBlockUI;

  @Input() title!: string;
  @Input() set url ( url: string ) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  safeUrl : SafeResourceUrl | null = null;
  isLoaded: boolean                = false;

  constructor (
    public activeModal: NgbActiveModal,
    private sanitizer : DomSanitizer
  ) {}

  ngOnInit () : void {
    this.playerBlock.start();
  }

  onIframeLoad () : void {
    setTimeout(() => {
      this.isLoaded = true;
      this.playerBlock.stop();
    }, VehicleVisualsPlayerComponent.IFRAME_READY_DELAY_MS);
  }
}
